let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fIF1H")).then(() => parcelRequire('fhDJg'));